<template>
  <div>
    <ul 
      v-show="cfg.count_items > cfg.page_size || cfg.count_pages > 1" 
      :class="['pagination pagination-restyle',mix_class?mix_class:'']">

      <li 
        @click="setPage(cfg.page_current-1<=0?1:cfg.page_current-1)" 
        class="page-item mr-2"> 
        <span class="page-link" title="Previous" style="border: none;">
          <i class="fa fa-angle-left"></i>
        </span>
      </li>

      <!-- 1 -->
      <li 
        v-if="pages_available.indexOf(1) === -1"
        @click="setPage(1)"
        :class="['page-item',{'on':cfg.page_current === 1}]"
        >
        <span class="page-link">{{1}}</span>
      </li>
      <li v-if="pages_available.indexOf(1) === -1" class="px-3 mb-none">...</li>

      <li 
        v-for="item of pages_available"
        @click="setPage(item)"
        :class="['page-item',{'on':cfg.page_current === item}]"
        :key="item">
        <span class="page-link">{{item}}</span>
      </li>

      <!-- cfg.count_pages 最大页码 -->
      <li v-if="pages_available.indexOf(cfg.count_pages) === -1" class="px-3 mb-none">...</li>
      <li 
        v-if="pages_available.indexOf(cfg.count_pages) === -1"
        @click="setPage(cfg.count_pages)"
        :class="['page-item',{'on':cfg.page_current === cfg.count_pages}]"
        >
        <span class="page-link">{{cfg.count_pages}}</span>
      </li>

      <li 
        @click="setPage(cfg.page_current+1>render_log.end_max?render_log.end_max:cfg.page_current+1)" 
        class="page-item ml-2">
        <span class="page-link" title="Next" style="border: none;">
          <i class="fa fa-angle-right"></i>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
// 使用须知：
// mix_class 是用来混入class的
// count_items 大于0，或 count_pages 大于0，表示有数据，这时组件才显示

// config 常用配置示例：
// {
//   'page-size': 10, //每页条目数量
//   'page-current': 1, // 当前页
//   'count_items': 100, //总个数，和总页数选填其一
//   'btn_num': 5, // 按钮个数
//   'turnpage_top': true, // 翻页时操作滚动置顶
//   'count_pages': 100, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
// }

// 触发父组件更新： @reloadList="getXxxList()"

export default {
  name: 'pagination',
  props:[
    'mix_class',
    'conf',
  ],
  data(){
    return{
      pages_available: [],

      render_log: null,
    }
  },
  computed:{
    cfg(){
      let temp = Object.assign({
        "page_size": 10,
        "page_current": 1,
        "count_items": null,
        "count_pages": null,
        "btn_num": 5,
      },this.conf)

      return temp
    },
  },
  watch:{
    cfg:{
      'deep': true,
      'handler': function(){
        this.render()
      }
    },
  },
  methods: {
    // dom 渲染
    render(){
      let cfg = this.cfg

      // 没有数据时，停止渲染
      if(cfg.count_items === 0 && cfg.count_pages === 0){
        return
      }
      let start = cfg.page_current - parseInt(cfg.btn_num/2)
      let end = cfg.page_current + parseInt(cfg.btn_num/2)
      let end_max = cfg.count_pages || Math.ceil(cfg.count_items/cfg.page_size)

      // 确定起始页码
      if(start < 1){
        end = end + (1-start)
        start = 1
      }
      // 确定终止页码
      if(end > end_max){
        start = start - (end - end_max)

        end = end_max
        if(start < 1){
          start = 1
        }
      }

      // 记录个日志
      this.render_log = {
        start,
        end,
        end_max,
      }

      // 赋值循环项
      let temp = []
      for(let i = start; i <= end; i++){
        temp.push(i)
      }
      this.pages_available = temp
    },

    // set 
    setPage(page_num){
      // 
      if(page_num === this.conf.page_current){
        return
      }
      this.conf.page_current = page_num

      this.$emit('reloadList')

    },
  },
  created(){
    this.render()
  },
}
</script>

<style lang="scss">
.pagination-restyle{
  .page-link{
    color: #1a1a1a;
    transition: all .2s;
    background-color: transparent;
    cursor: pointer;
    &:hover{
      color: #1a1a1a;
    }
  }
  .page-item{
    min-width: 38px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    border-radius: 0;
  }
  .page-item:first-child .page-link{
    border-radius: 0;
  }
  .page-item:last-child .page-link{
    border-radius: 0;
  }
  .on{
    .page-link{
      background-color: #1a1a1a;
      color: #fff;
    }
  }
}
</style>
